import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

// Fix default icon path
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeUrls = true;

const customIcon = new L.DivIcon({
  className: "custom-iv-pin",
  html: `<div style="
    width: 36px; height: 36px;
    background: #064E3B;
    border: 3px solid white;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
    display: flex; align-items: center; justify-content: center;
  ">
    <span style="transform: rotate(45deg); color: white; font-weight: 700; font-size: 14px; font-family: 'Outfit', sans-serif;">★</span>
  </div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 36],
  popupAnchor: [0, -32],
});

const cityIcon = (count) => new L.DivIcon({
  className: "custom-city-pin",
  html: `<div style="
    min-width: 44px; height: 44px; padding: 0 8px;
    background: white;
    border: 2px solid #064E3B;
    border-radius: 22px;
    box-shadow: 0 4px 14px rgba(6,78,59,0.25);
    display: flex; align-items: center; justify-content: center;
    color: #064E3B; font-weight: 700; font-size: 13px; font-family: 'Outfit', sans-serif;
  ">${count}</div>`,
  iconSize: [44, 44],
  iconAnchor: [22, 22],
});

function FitBounds({ markers }) {
  const map = useMap();
  useEffect(() => {
    if (!markers || markers.length === 0) return;
    const bounds = L.latLngBounds(markers.map((m) => [m.lat, m.lng]));
    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 11 });
  }, [markers, map]);
  return null;
}

export default function ProvidersMap({ markers = [], height = "500px", center = [39.5, -98.35], zoom = 4, fitBounds = true, kind = "provider" }) {
  return (
    <div className="rounded-2xl overflow-hidden border border-stone-200" style={{ height }} data-testid="providers-map">
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        {markers.map((m, i) => (
          <Marker
            key={m.id || i}
            position={[m.lat, m.lng]}
            icon={kind === "city" ? cityIcon(m.count || 1) : customIcon}
          >
            <Popup>
              <div className="font-display" style={{ minWidth: 180 }}>
                <div className="font-semibold text-stone-900">{m.name || m.city}</div>
                {m.state && <div className="text-xs text-stone-500">{m.city ? `${m.city}, ${m.state}` : m.state}</div>}
                {m.count !== undefined && <div className="text-xs text-stone-600 mt-1">{m.count} providers</div>}
                {m.slug && (
                  <a href={`/listing/${m.slug}`} className="block mt-2 text-xs font-semibold text-[#064E3B]">View profile →</a>
                )}
                {!m.slug && m.city && (
                  <a href={`/search?city=${encodeURIComponent(m.city)}`} className="block mt-2 text-xs font-semibold text-[#064E3B]">Browse providers →</a>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
        {fitBounds && markers.length > 0 && <FitBounds markers={markers} />}
      </MapContainer>
    </div>
  );
}
